import { Button, VStack } from '@chakra-ui/react';
import { NoticePanel } from '@fluenceur/ui';

type DashboardAlertTone = 'info' | 'warning';

interface DashboardAlertAction {
  id: string;
  label: string;
  onClick: () => void;
  loading?: boolean;
  variant?: 'solid' | 'ghost';
}

export interface DashboardAlertDescriptor {
  id: string;
  tone: DashboardAlertTone;
  title: string;
  description: string;
  actions?: DashboardAlertAction[];
}

interface DashboardAlertListProps {
  alerts: DashboardAlertDescriptor[];
}

export default function DashboardAlertList({ alerts }: DashboardAlertListProps) {
  if (!alerts.length) return null;

  return (
    <VStack gap={3} alignItems="stretch">
      {alerts.map((alert) => (
        <NoticePanel
          key={alert.id}
          tone={alert.tone}
          title={alert.title}
          actions={
            alert.actions?.length ? (
              <>
                {alert.actions.map((action) => (
                  <Button
                    key={action.id}
                    size="sm"
                    variant={action.variant ?? 'solid'}
                    colorPalette="gray"
                    loading={action.loading}
                    onClick={action.onClick}
                  >
                    {action.label}
                  </Button>
                ))}
              </>
            ) : undefined
          }
        >
          {alert.description}
        </NoticePanel>
      ))}
    </VStack>
  );
}
